import React from 'react';
import { Box, Typography } from '@mui/material';

export interface KeyValueItem {
  label: string;
  value: React.ReactNode;
  /** Let one value take the full row (descriptions, long text). */
  fullWidth?: boolean;
}

interface KeyValueListProps {
  items: KeyValueItem[];
  /** 1 or 2 columns from the small breakpoint up; always 1 on phones. */
  columns?: 1 | 2;
}

const isEmpty = (value: React.ReactNode) => value === null || value === undefined || value === '';

/**
 * Label/value metadata as a definition list. Missing values read as an em
 * dash, never "Unknown" or "undefined".
 */
const KeyValueList: React.FC<KeyValueListProps> = ({ items, columns = 2 }) => (
  <Box
    component="dl"
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', sm: columns === 2 ? 'repeat(2, minmax(0, 1fr))' : '1fr' },
      columnGap: 4,
      rowGap: 2.25,
      m: 0,
    }}
  >
    {items.map((item) => (
      <Box key={item.label} sx={{ minWidth: 0, gridColumn: item.fullWidth ? '1 / -1' : undefined }}>
        <Typography component="dt" variant="body2" color="text.secondary" sx={{ mb: 0.25 }}>
          {item.label}
        </Typography>
        <Typography component="dd" variant="body2" sx={{ m: 0, fontWeight: 500, color: 'text.primary', overflowWrap: 'anywhere' }}>
          {isEmpty(item.value) ? '—' : item.value}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default KeyValueList;
